export const CHANGE_TITLE = "CHANGE_TITLE";
export const CHANGE_DRAWER_MENU = "CHANGE_DRAWER_MENU";
export const CHANGE_RIGHT_ACTION = "CHANGE_RIGHT_ACTION";
export const CHANGE_HEADER_TITLE_AND_ACTION = "CHANGE_HEADER_TITLE_AND_ACTION";
export const SHOW_SNACK_TOAST = "SHOW_SNACK_TOAST";
export const HIDE_SNACK_TOAST = "HIDE_SNACK_TOAST";
export type SnackType = "success" | "warning" | "info" | "error";
export interface HeaderAction {
  type: string;
  title?: string;
  snackType?: SnackType;
  drawer?: boolean;
  rightEnabled?: boolean;
  rightText?: string;
  rightAction?: () => void;
  showSearch?: boolean;
  onSearchText?: (txt: string) => void;
}

export interface HeaderState {
  title: string;
  drawMenuOpen: boolean;
  rightEnabled: boolean;
  rightText?: string;
  rightAction?: () => void;
  showSnack: boolean;
  snackTitle: string;
  showSearch: boolean;
  snackType: SnackType;
  onSearchText?: (txt: string) => void;
}



// WEBPACK FOOTER //
// ./src/store/header/types.ts